<template>
    <div
        v-show="showDelete"
        class="delete-modal"
    >
        <modal
            :show="showDelete"
            modal-classes="modal-secondary"
            :data-cy="'deleteModal'"
            @close="$emit('close-delete')"
        >
            <template slot="header">
                <h1>{{ $t("pages.contact.deleteModalTitle") }}</h1>
            </template>

            <p>
                {{ $t("pages.contact.deleteMessage", { contactName: contactName }) }}
            </p>
            <p>
                {{ $t("modalMessages.unrecoverableOperationMessage") }}
            </p>

            <template slot="footer">
                <base-button
                    type="submit"
                    class="btn btn-danger"
                    :loading="loading"
                    :data-cy="'buttonDeleteConfirm'"
                    @click="deleteContact"
                >
                    {{ $t("actions.delete") }}
                </base-button>
                <base-button
                    type="button"
                    class="btn btn-neutral"
                    :data-cy="'buttonDeleteStop'"
                    @click="$emit('close-delete')"
                >
                    {{ $t("actions.cancel") }}
                </base-button>
            </template>
        </modal>
    </div>
</template>

<script>
import { contactClient } from "@/clients/contactClient";
import exceptionsMixins from "@/mixins/exceptionsMixins";

export default {
    name: 'DeleteContact',
    mixins: [
        exceptionsMixins
    ],
    props: {
        deleteContactId: {
            type: Number,
        },
        contactName: {
            type: String,
        },
        showDelete: {
            type: Boolean,
        }
    },
    data() {
        return {
            loading: false,
        }
    },
    methods: {
        deleteContact() {
            this.loading = true;
            contactClient.deleteContact(this.deleteContactId).then(() => {
                this.$notify({
                    type: "success",
                    icon: "ni ni-notification-70",
                    message: this.$t("notifications.success.deleted")
                });
                this.$emit('data-changed');
            }).catch((error) => {
                this.manageException(error.response);
            }).then(() => {
                this.loading = false;
                this.$emit('close-delete');
            });
        },
    }
}
</script>
